import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonWithCane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.11 4.22C11.11 5.75 9.86 7 8.33 7 6.8 7 5.55 5.75 5.55 4.22v-.45C5.55 2.24 6.8.99 8.33.99c1.53 0 2.78 1.25 2.78 2.78v.45ZM8.33 3c-.43 0-.78.35-.78.78v.45a.781.781 0 0 0 1.56 0v-.45c0-.43-.35-.78-.78-.78Zm3.04 7.05 2.79.46h.01c.54.09.91.61.82 1.15-.09.54-.61.92-1.15.82l-3-.5a.933.933 0 0 1-.39-.15L9 10.87v3.83l1.83 2.75c.07.09.11.2.14.31l1 4a1 1 0 0 1-.73 1.21c-.08.03-.16.03-.24.03-.45 0-.86-.3-.97-.76l-.96-3.83-1.9-2.86A.967.967 0 0 1 7 15v-4l-1.82 1.37.77 2.32a.992.992 0 0 1-.63 1.26c-.11.03-.22.05-.32.05-.42 0-.81-.26-.95-.68l-1-3c-.13-.41.01-.86.35-1.12l4.01-3.01a.61.61 0 0 1 .14-.07c.013-.004.026-.012.04-.021.018-.011.037-.023.06-.029.11-.04.22-.07.34-.07H8c.01 0 .02.002.03.005.01.002.02.005.03.005.09.01.19.03.28.06.03.007.054.02.08.035l.03.015c.03.02.1.05.1.05l2.82 1.88Zm-5.26 7.51c.24-.5.84-.7 1.34-.45l.01.01c.5.25.7.85.45 1.34l-2 4a1.007 1.007 0 0 1-1.35.44c-.5-.25-.7-.85-.45-1.34l2-4ZM17.5 11a2.5 2.5 0 0 0-2.5 2.5V22c0 .55.45 1 1 1s1-.45 1-1v-8.5c0-.28.22-.5.5-.5s.5.22.5.5v.5c0 .55.45 1 1 1s1-.45 1-1v-.5a2.5 2.5 0 0 0-2.5-2.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonWithCane;
